var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state)?_c('div',[(!_vm.showSuccess)?_c('span',[_vm._v("/")]):_vm._e(),_vm._v(" "),_c('BadgeState',{attrs:{"label":_vm.vmiResource.migrationState.status,"color":_vm.vmiResource.migrationStateBackground}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }